import { render, staticRenderFns } from "./StatistiquesCourse.vue?vue&type=template&id=12280c5c&scoped=true&"
import script from "./StatistiquesCourse.vue?vue&type=script&lang=js&"
export * from "./StatistiquesCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12280c5c",
  null
  
)

export default component.exports